<template>
  <div class="meeting-empty__wrapper">
    <h1 class="meeting-empty__title">{{ title }}</h1>
    <p class="meeting-empty__description">{{ description }}</p>
    <img
      class="meeting_empty__img"
      src="@/assets/images/pages/meeting/blank_meeting.svg"
      alt="Image de reunião vazia"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  name: "vacancy-empty-card"
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/meetingemptycard.scss";
</style>
